import './styles/BlankPage.scss';

interface Props {}

const BlankPage:React.FC<Props> = ({}) => {
    return(
        <div className='BlankPage' />
    );
};
export default BlankPage;